// extracted by mini-css-extract-plugin
export default {"root":"root___WEWnD","container":"container___RJVOm","text":"text___Bunpe","image":"image___g6Oeh","button":"button___McvnK"};